import { Poppins, Agbalumo } from 'next/font/google';

const poppins = Poppins({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-poppins',
  weight: ['400', '700', '900'],
});

const agbalumo = Agbalumo({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-agbalumo',
  weight: ['400'],
});

export const supportedFonts = [poppins, agbalumo];
